// Mock data for 411 Tech Savvy website

export const company = {
  name: "411TechSavvy",
  tagline: "Digital Media Marketing & Tech Expert Analyst",
  owner: "Eddie Kirk AzTn",
  role: "Web Media Tech Analyst | USMC Veteran",
  phone: "615-461-5909",
  email: "mainoffice.411techsavvy@gmail.com",
  location: "Nashville, TN & Phoenix, AZ  Serving Nationwide",
  locations: [
    { city: "Nashville", state: "TN", label: "Nashville, Tennessee" },
    { city: "Phoenix", state: "AZ", label: "Phoenix, Arizona" },
  ],
  experience: "20+ Years",
  site: "www.411ts.site",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "FAQ", href: "#faq" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const heroStats = [
  { value: "20+", label: "Years Experience" },
  { value: "2", label: "Office Locations" },
  { value: "USMC", label: "Veteran Owned" },
  { value: "USA", label: "Nationwide Service" },
];

export const featuredServices = [
  {
    title: "AI Website Design & Build",
    desc: "NLP-powered websites with attractive content designed to convert. Fix ROI issues and build sites that get found.",
    img: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80",
    icon: "Sparkles",
  },
  {
    title: "Local Voice Search Findability",
    desc: "Get discovered on Google, Alexa, Bixby, Siri, Cortana and across 300+ listing platforms.",
    img: "https://images.unsplash.com/photo-1557838923-2985c318be48?w=800&q=80",
    icon: "Mic",
  },
  {
    title: "SEO & AEO Optimization",
    desc: "AI-driven Search and Ask Engine Optimization that creates compelling organic content that drives engagement.",
    img: "https://images.pexels.com/photos/7651801/pexels-photo-7651801.jpeg?w=800",
    icon: "TrendingUp",
  },
];

export const allServices = [
  { name: "Internet Marketing & AEO", icon: "Globe" },
  { name: "AI Website Design & Build", icon: "Code2" },
  { name: "Lead Generation", icon: "Target" },
  { name: "Local Voice Search Findability", icon: "Mic" },
  { name: "Targeted Lead List", icon: "ListChecks" },
  { name: "Reputation Management", icon: "ShieldCheck" },
  { name: "Integrated CRM Marketing", icon: "Users" },
  { name: "AI Virtual Admin Assistance", icon: "Bot" },
  { name: "Google Business Profile Compliance", icon: "BadgeCheck" },
  { name: "Digital / Virtual Business Cards", icon: "CreditCard" },
  { name: "IT Remote Technical Support", icon: "Headphones" },
  { name: "Computer Programming", icon: "Terminal" },
  { name: "Online Branding", icon: "Palette" },
  { name: "E-Commerce Solutions", icon: "ShoppingCart" },
  { name: "SaaS Service Setup", icon: "Cloud" },
  { name: "PC & Smartphone Consulting", icon: "Smartphone" },
  { name: "Automated Systems & Tech", icon: "Cpu" },
  { name: "Telemarketing Technology", icon: "PhoneCall" },
  { name: "Financial & Marketing Consulting", icon: "LineChart" },
  { name: "Business Networking Company", icon: "Network" },
  { name: "Social Media Management", icon: "Share2" },
  { name: "Google Business Listing", icon: "MapPin" },
  { name: "Google Listing Removal", icon: "Trash2" },
  { name: "PC & Android Smartphone Support", icon: "Monitor" },
];

export const testimonials = [
  {
    name: "Jason D.",
    role: "Small Business Owner",
    quote: "Exceptional service in websites. Eddie's AI approach is top-notch and our online traffic has tripled!",
    img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&q=80",
    rating: 5,
  },
  {
    name: "Steve O.",
    role: "Restaurant Owner",
    quote: "Outstanding social media advertising! Eddie is experienced, professional and results-driven.",
    img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&q=80",
    rating: 5,
  },
  {
    name: "Cory J.",
    role: "Contractor",
    quote: "Best in the industry for getting found on Google. Highly recommend his consulting services.",
    img: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?w=200&q=80",
    rating: 5,
  },
];

export const faqs = [
  {
    q: "What services does 411TechSavvy offer?",
    a: "We offer a full suite of digital marketing and IT services including AI-powered website design, SEO/AEO optimization, lead generation, local voice search findability, social media management, Google Business Profile management, CRM automation, IT remote support and digital business cards.",
  },
  {
    q: "Who is Eddie Kirk and what makes him qualified?",
    a: "Eddie Kirk AzTn is a USMC veteran and Web Media Tech Analyst with 20+ years of combined business and technical experience. He specializes in helping local businesses leverage the newest AI technologies to outshine competitors.",
  },
  {
    q: "What is AI Website Design and how is it different?",
    a: "Our AI-built websites use Natural Language Programming (NLP) and machine learning to create content, graphics and conversion paths automatically optimized to your audience. They load faster, rank higher and convert better than traditional sites.",
  },
  {
    q: "How does Local Voice Search Findability work?",
    a: "We list and optimize your business across 300+ voice and search directories (Google, Alexa, Bixby, Siri, Cortana, Yelp, Apple Maps, etc.) so customers can find you no matter how they search.",
  },
  {
    q: "Do you offer IT support for computers and smartphones?",
    a: "Yes. We provide remote technical support, troubleshooting and consulting for PCs, Macs and Android smartphones  perfect for small businesses without a dedicated IT department.",
  },
  {
    q: "What is a Digital Business Card?",
    a: "A Digital Business Card is a modern, shareable virtual card with your photo, contact info, links, services and reviews  all delivered through a QR code or short URL. No paper, easy updates, instant sharing.",
  },
  {
    q: "How long until I see results from SEO?",
    a: "Most clients see early improvements within 30-60 days. Significant ranking gains and traffic typically appear in 3-6 months, depending on your industry and competition.",
  },
  {
    q: "Do you work with businesses outside Nashville or Phoenix?",
    a: "Absolutely. With offices in Nashville, TN and Phoenix, AZ, we serve clients anywhere in the USA via Zoom and FaceTime. Face-to-face is great, but we can do everything remotely too.",
  },
  {
    q: "How much do your services cost?",
    a: "Pricing depends on the scope of your project. We offer affordable packages for small businesses and custom quotes for larger needs. Call 615-461-5909 for a free consultation.",
  },
  {
    q: "Do you donate to charity?",
    a: "Yes! A portion of every dollar you spend with 411TechSavvy goes to charities we support. Every project you fund helps a greater cause.",
  },
];

export const chatbotSuggestions = [
  "What services do you offer?",
  "Tell me about AI website design",
  "How much does SEO cost?",
  "Do you serve businesses outside Nashville?",
  "How do I contact Eddie?",
];

export const chatbotKnowledge = {
  greetings: ["hello", "hi", "hey", "good morning", "good afternoon"],
  responses: {
    services:
      "411TechSavvy offers AI Website Design, SEO/AEO optimization, Lead Generation, Local Voice Search Findability, Social Media Management, Google Business Profile, CRM automation, Digital Business Cards and IT Remote Support. Which area interests you most?",
    ai: "Our AI websites use NLP and machine learning to generate optimized content, graphics and conversion paths. They load fast, rank well in Google and convert visitors into customers.",
    seo: "Our SEO uses AI to create compelling organic content. Pricing depends on competition and scope. Most clients see early gains in 30-60 days. Call 615-461-5909 for a free quote!",
    location: "We're based in Nashville TN but serve businesses anywhere in the USA via Zoom and FaceTime.",
    contact: "You can reach Eddie directly at 615-461-5909 or fill out the contact form below. He typically responds within 24 hours.",
    cost: "Pricing depends on your project. We offer affordable packages for small businesses. Call 615-461-5909 for a free consultation.",
    eddie: "Eddie Kirk AzTn is a USMC veteran with 20+ years in business and tech. He's your friendly neighborhood IT Tech Savvy Guy in Nashville!",
    default:
      "Great question! For specific details, please call Eddie at 615-461-5909 or fill out the contact form below. You can also browse our FAQ section above.",
  },
};
